import ReactDOM from "react-dom/client";
import "./index.css";
import { PublicClientApplication } from "@azure/msal-browser";
import {
  API_SCOPES,
  MSAL_CONFIG,
} from "./Azure/azure-authentication-config";
import { rememberAccount, trySilentSso } from "./services/auth/silent-sso";
import { App } from "./App";

export const msalInstance = new PublicClientApplication(MSAL_CONFIG);

(async () => {
  await msalInstance.initialize();

  // Reuse a Microsoft session from another PBS app before the /login page can
  // show: one prompt:none redirect per tab. True = the page is leaving for
  // Microsoft, so render nothing.
  if (await trySilentSso(msalInstance, API_SCOPES)) return;
  // Shares this account as the login hint with every *.teampbs.com app.
  rememberAccount(msalInstance);

  // Default to using the first account if no account is active on page load
  if (
    !msalInstance.getActiveAccount() &&
    msalInstance.getAllAccounts().length > 0
  ) {
    // Account selection logic is app dependent. Adjust as needed for different use cases.
    msalInstance.setActiveAccount(msalInstance.getAllAccounts()[0]);
  }
  // Optional - This will update account state if a user signs in from another tab or window
  msalInstance.enableAccountStorageEvents();

  const root = ReactDOM.createRoot(
    document.getElementById("rootMySite") as HTMLElement
  );
  root.render(<App instance={msalInstance} />);
})();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
